<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-center.mb-5
      .col
        h1.m-0.font-italic.d-inline-block.align-middle
          | Histórico&nbsp;
          span.ad_text-secondary {{user.name}}
      .col-2.text-center
        .ad_select.w-100
          select(v-model="year", @change='changeYear($event)')
            option(:value="null" disabled) Selecciona Año
            option(:value="n" v-for="n in years") {{n}}
      .col-2.text-center
        .ad_select.w-100
          select(v-model="month", @change='changeMonth($event)')
            option(:value="null" disabled) Selecciona Mes
            option(:value="n" v-for="n in months") {{meses[n-1]}}

    section
      .d-flex.row.flex-row.align-items-start.mt-4
        .col
          .card.p-0.ad_border2-primaryLight.rounded-xl
            .card-body
              .col.ad_bg-gray.rounded-lg.py-3.mb-3(v-for="(week, indexw) in weeksNumbers" width="16%" colspan="5" scope="colgroup")
                h3.ad_text-primary.font-weight-bold Semana {{ week}}
                table.w-100.text-left.table-rounded-body.espacing-table
                  tr
                    th
                    //Semana 1
                    th.text-center.font-weight-bold( scope="col")
                      | PS
                    th.text-center.font-weight-bold( scope="col")
                      | DDD
                    th.text-center.font-weight-bold( scope="col")
                      | CP
                    th.text-center.font-weight-bold( scope="col")
                      | SDA
                    th.text-center.font-weight-bold( scope="col")
                      | SDB
                    
                  tbody
                    tr(v-for="(collaborator, index) in collabs")       
                      td
                        div.font-weight-bold
                          | {{collaborator.name}}
                      //Semana 1
                      td
                        div.justify-content-center
                          | {{(typeof collaborator.weeks[indexw].PS) != 'number' ? collaborator.weeks[indexw].PS : collaborator.weeks[indexw].PS + '%'}}
                      td
                        div.justify-content-center
                          | {{(typeof collaborator.weeks[indexw].DDD != 'number') ? collaborator.weeks[indexw].DDD: collaborator.weeks[indexw].DDD + '%'}}
                      td
                        div.justify-content-center
                          | {{(typeof collaborator.weeks[indexw].CP != 'number') ? collaborator.weeks[indexw].CP: collaborator.weeks[indexw].CP + '%'}}
                      td
                        div.justify-content-center
                          | {{(typeof collaborator.weeks[indexw].SDA != 'number') ? collaborator.weeks[indexw].SDA: collaborator.weeks[indexw].SDA + '%'}}
                      td
                        div.justify-content-center
                          | {{(typeof collaborator.weeks[indexw].SDB != 'number') ? collaborator.weeks[indexw].SDB: collaborator.weeks[indexw].SDB + '%'}}    
                      
                  tfoot
                    tr
                      td
                        div.font-weight-bold.h5
                          | Promedios
                      //Semana 1
                      td(v-if="1 <=totals.length")
                        div.justify-content-center
                          | {{totals[indexw].PS.toFixed(2)}} %
                      td(v-if="1 <=totals.length")
                        div.justify-content-center
                          | {{totals[indexw].DDD.toFixed(2)}} %
                      td(v-if="1 <=totals.length")
                        div.justify-content-center
                          | {{totals[indexw].CP.toFixed(2)}} %
                      td(v-if="1 <=totals.length")
                        div.justify-content-center
                          | {{totals[indexw].SDA.toFixed(2)}} %
                      td(v-if="1 <=totals.length")
                        div.justify-content-center
                          | {{totals[indexw].SDB.toFixed(2)}} %    
                      
                      
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";

export default {

  name: 'ConsultorH',

  data () {
    return {
      user: {},
      year: null,
      years: [],
      month:null,
      months: [],
      weeksNumbers : [],
      collabs : [],
      totals: [],
      meses : [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre",
        ]
    }
  },
  methods: {
    moment,
    ...mapActions("user", ["getUserById"]),
    ...mapActions("consultant", ["getAnsweredGuidelinesHistory"]),
    getHistorical() {
      const vm = this;
      const user_evaluated = vm.$store.state.auth.user.id
      const loading = vm.$toast.loading("Cargando semanas...");      
      vm.getUserById(user_evaluated).then(response => {
        vm.user = response;
        const year = vm.year ? vm.year : 2019;
        const month = vm.month;
        const data = {
          user_evaluated,
          year, 
          month
        };
        vm.getAnsweredGuidelinesHistory(data).then(guidelines => { 
          vm.weeksNumbers = guidelines.weeksNumber;
          vm.collabs = guidelines.evaluatedUsers;
          vm.totals = guidelines.totals;
        });
      });
      loading.hide();
    },
    changeYear($event) {
      const vm = this;
      vm.getMonths();
      vm.getHistorical();
    },
    changeMonth($event) {
      const vm = this;
      vm.getHistorical();
    },
    getYears() {
      const vm = this;
      let currentYear = new Date().getFullYear();
      if(!vm.year) {
        vm.year = currentYear;
      }
      let startYear = 2019;
      let yearslist = [];  
      while ( startYear <= currentYear ) {
          yearslist.push(startYear++);
      }   
      vm.years = yearslist;
    },
    getMonths() {
      const vm = this;
      
      let startMonth = 1;
      let endMonth = new Date().getFullYear() == vm.year ? new Date().getMonth() + 1 : 12;
      if(!vm.month) {
        vm.month = endMonth;
      }
      let monthlist = [];  
      while ( startMonth <= endMonth ) {
          monthlist.push(startMonth++);
      }   
      
      vm.months = monthlist;
    }
  },
  mounted() {
    this.$nextTick(() => {
      const vm = this;
      vm.getYears();
      vm.getMonths();
      vm.getHistorical();
    })  
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/views/consultor-historico.vue